export const getArrayUniqueValues = <T>(arr: Array<T>) => [...new Set(arr)];
